import { Activity } from "@farmact/model/src/model/Employee";
import { useUserContext } from "../../components/authentication/Session/UserContext";

export interface UseCurrentActivityReturn {
    currentActivity: Activity | null;
    isLoading: boolean;
}

export function useCurrentActivity(): UseCurrentActivityReturn {
    const { employee, isLoading } = useUserContext();

    const currentActivity = employee?.currentActivity ?? null;

    return { currentActivity, isLoading };
}
